import React, { useState, useEffect, useContext } from 'react';
import usePortalAuth from '../../../auth/usePortalAuth';

import { Link } from 'react-router-dom';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

//--------------Material UI Imports--------------//
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import './MSSP.css';

const MSSPCreateClientButton = (props) => {
  const getTranslation = props.getTranslation || ((value) => value);
  const useStyles = makeStyles({
    header: {
      fontFamily: 'Montserrat, sans-serif',
      //fontWeight: 300
    },
  });

  const classes = useStyles();

  return (
    <IconButton
      onClick={props.toggleMSSPNewFeatureDialogue}
      style={{ marginLeft: '25px', color: '#3f51b5' }}
      aria-label="upload picture"
      component="span"
    >
      <Tooltip title={getTranslation('Create Client', props.preferredLanguage)}>
        <AddCircleOutlineOutlinedIcon id="MSSPCreateClientButton" fontSize="large" />
      </Tooltip>
    </IconButton>
  );
};
export default MSSPCreateClientButton;
